import React from 'react';
import { isSafari } from '~utils/helpers';
import Block from '~routes/main/userprofile/block';
import ActivityLoader from '~routes/main/userprofile/activity/loader';
import EventsListLoader from '~routes/main/userprofile/events-list/loader';

function TabTeamLoader() {
    const windowWidth = isSafari() ? document.documentElement.clientWidth : window.innerWidth;
    const isMobile = windowWidth < 1160;
    return (
        <div className="events-tab">
            <Block>
                <ActivityLoader isMobile={isMobile}/>
            </Block>
            <Block>
                <EventsListLoader isMobile={isMobile}/>
            </Block>
        </div>
    );
}

export default TabTeamLoader;
export { TabTeamLoader };



// WEBPACK FOOTER //
// ./src/routes/main/userprofile/tab-events/loader/index.js